// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3nl78","sendOtp":"AuthorizeToLogin_sendOtp__m9NMb"};